export default __webpack_public_path__ + "static/media/Crane_Lift.97d24a5a.gif";